export const TERMS_URL = 'https://www.thisandthat.chat/terms';
export const PRIVACY_POLICY_URL =
  'https://www.thisandthat.chat/assistant-privacy-policy';
export const SECURITY_URL = 'https://www.thisandthat.chat/security';
export const DPA_URL = 'https://www.thisandthat.chat/dpa/';
export const BEDROCK_URL = 'https://aws.amazon.com/bedrock';
